import { render, staticRenderFns } from "./CaveonContent.vue?vue&type=template&id=e7c53140&"
import script from "./CaveonContent.vue?vue&type=script&lang=js&"
export * from "./CaveonContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports